import React, { useEffect } from "react";
import StudentLoginBg from "../assets/student-login-bg.png";
import TeacherQueryImg from "../assets/teacher-klasscode-help.png";
import { KlassCodeInput } from "./KlassCodeInput";
import { RememberMeForStudent } from "./RememberMeForStudent";
import './styles.scss';
import { useAuthSigninState } from "./../../authSignin/state";
import { pushEventToGTM } from "../../commonHelpers/pushEventToGTM";
import { SuiTurnstileProvider, TurnstileEnabledFeature } from "schoolUiComponents/SuiTurnstile";
import { setupHideElementsObserver } from "../../teacherDashboard/teacher/config/common";

export const StudentKlassCodeLogin = () => {
  const { sendEvent, getFromPage } = useAuthSigninState();

  useEffect(() => {
    if (window.location.hash.includes('student-klasscode')) {
      trackEventsForGuests("Viewed Class Code Input Screen", { "mp_login_user_type": "student", "From page": getFromPage() || "Direct URL entered" }, { send_mixpanel: true })
    }
    pushEventToGTM('viewed_class_code_screen', { 'Intent for': 'login', 'Screen type': 'page', 'From Page': 'signin' })

    // Set up observer to hide consent and overlay elements
    const cleanupObserver = setupHideElementsObserver();

    return () => {
      // Clean up observer and restore elements
      cleanupObserver();
    }
  }, [])

  const userNameLoginClickHandler = () => {
    sendInteractedEvent({ clickedOn: "Login via QR code" })
    // trackAnalyticsEvent('Student Login Via username');
    // sendEvent(`Student Login Via username`)
  }

  const sendInteractedEvent = ({ interactionDetails = '', clickedOn = '' }) => {
    trackEventsForGuests("Interacted Class Code Input Screen", { "mp_login_user_type": "student", "Interaction details": interactionDetails, "Clicked on": clickedOn }, { send_mixpanel: true })
  }

  return (
    <SuiTurnstileProvider action={"KLASS_CODE_LOGIN"} userType={"student"} featureName={TurnstileEnabledFeature.klass_code_login}>
      <div className="student-login">
        <button className="login-back" onClick={() => { sendInteractedEvent({ clickedOn: "Back Button" }); window.location.hash = "#student" }} aria-label="Go back"><i className="iconcust-iconBackBtn"></i></button>
        <div className="student-login-bg">
          <img src={StudentLoginBg} alt="" />
        </div>
        <div className={`student-login-body`}>
          <h4>Enter your Class Code</h4>
          <KlassCodeInput />
          <p>
            Login via <a href="#student-qrcode?fromPage=Class code input screen" onClick={userNameLoginClickHandler} aria-label="Login via QR code">QR code</a>
          </p>
          <img
            src={TeacherQueryImg}
            alt="Don’t know your class code? Ask your teacher for help"
          />
        </div>
      </div>
    </SuiTurnstileProvider>
  );
};
